import rolesService from '@/services/roles.service'

export default {
  namespaced: true,
  state: {
    roles: [],
    permissions: [],
    loading: false,
    error: null
  },
  mutations: {
    SET_ROLES(state, roles) {
      state.roles = roles
    },
    SET_PERMISSIONS(state, permissions) {
      state.permissions = permissions
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    SET_ERROR(state, error) {
      state.error = error
    },
    ADD_ROLE(state, role) {
      state.roles.push(role)
    },
    UPDATE_ROLE(state, updatedRole) {
      const index = state.roles.findIndex(r => r.id === updatedRole.id)
      if (index !== -1) {
        state.roles.splice(index, 1, updatedRole)
      }
    }
  },
  actions: {
    async fetchRoles({ commit }) {
      try {
        commit('SET_LOADING', true)
        commit('SET_ERROR', null)
        const response = await rolesService.getAll()
        const roles = response.data?.data || response.data || []
        commit('SET_ROLES', roles)
      } catch (error) {
        commit('SET_ERROR', error.response?.data?.message || error.message)
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async fetchPermissions({ commit }) {
      try {
        commit('SET_LOADING', true)
        commit('SET_ERROR', null)
        const response = await rolesService.getPermissions()
        const permissions = response.data || []
        commit('SET_PERMISSIONS', permissions)
      } catch (error) {
        commit('SET_ERROR', error.response?.data?.message || error.message)
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async createRole({ commit }, roleData) {
      try {
        commit('SET_LOADING', true)
        commit('SET_ERROR', null)
        const response = await rolesService.create(roleData)
        if (response.success) {
          commit('ADD_ROLE', response.data)
          return { success: true, data: response.data }
        }
        throw new Error(response.message)
      } catch (error) {
        const errorMessage = error.response?.data?.message || error.message
        commit('SET_ERROR', errorMessage)
        return { success: false, error: errorMessage }
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async updateRole({ commit }, { id, roleData }) {
      try {
        commit('SET_LOADING', true)
        commit('SET_ERROR', null)
        const response = await rolesService.update(id, roleData)
        if (response.success) {
          commit('UPDATE_ROLE', response.data)
          return { success: true, data: response.data }
        }
        throw new Error(response.message)
      } catch (error) {
        const errorMessage = error.response?.data?.message || error.message
        commit('SET_ERROR', errorMessage)
        return { success: false, error: errorMessage }
      } finally {
        commit('SET_LOADING', false)
      }
    }
  },
  getters: {
    allRoles: state => state.roles,
    allPermissions: state => state.permissions,
    isLoading: state => state.loading
  }
}

